<template>
  <div class="base-text-1" v-html="text"/>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-1 {
  font-family: 'Klavika Medium';
  text-align: left;
}
</style>
